<template>
  <div
    v-track="{
      ...track,
      resource:
        item.resType === '07' && item.extendData ? item.extendData : item,
    }"
    :class="_.item"
    @click="
      $dmbcResourceClick(
        item.resType === '07' && item.extendData ? item.extendData : item,
      )
    "
  >
    <dmbc-base-square :class="_.cover">
      <img
        :src="
          item.resType === '07' && item.extendData
            ? item.extendData.icon
            : item.icon
        "
        :class="_.image"
      />
      <img v-if="coverFrame" :src="coverFrame" :class="_.frame" />
    </dmbc-base-square>
    <div :class="_.content">
      <template
        v-if="
          item.resType !== '07' || (item.resType === '07' && item.extendData)
        "
      >
        <div :class="_.name">
          {{ item.resType !== '07' ? item.title : item.extendData.title }}
        </div>
        <div
          v-if="
            showTags &&
            (item.resType !== '07' ? item.tags : item.extendData.tags).length
          "
          :class="_.tags"
        >
          <div
            v-for="tag in item.resType !== '07'
              ? item.tags
              : item.extendData.tags"
            :key="tag"
            :class="_.tag"
          >
            {{ tag }}
          </div>
        </div>
        <div
          v-if="
            +(item.resType !== '07'
              ? item.discountAmt
              : item.extendData.discountAmt)
          "
          :class="_.extra"
        >
          <div :class="_.price">
            <span>￥</span
            >{{
              item.resType !== '07'
                ? item.discountAmt
                : item.extendData.discountAmt
            }}<i v-if="item.resType === '03'">起</i>
          </div>
          <div :class="_.sales">
            销量
            {{ item.resType !== '07' ? item.sales : item.extendData.sales }}
          </div>
        </div>
      </template>
      <div
        v-if="item.resType === '07'"
        :class="_.strategy"
        @click.stop="$dmbcResourceClick(item)"
      >
        <div :class="_.strategyContent">
          <div :class="_.strategyName">
            {{ item.title }}
          </div>
          <div v-if="item.subTitle" :class="_.strategyDesc">
            {{ item.subTitle }}
          </div>
        </div>
        <img :src="require('./images/箭头.png')" :class="_.strategyArrow" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      item: {
        type: null,
        required: true,
      },
      coverFrame: {
        type: String,
        default: '',
      },
      showTags: {
        type: Boolean,
        default: true,
      },
      track: {
        type: Object,
        default: () => ({}),
      },
    },
  })
</script>

<style lang="scss" module="_">
  .item {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;

    .cover {
      .image {
        object-fit: cover;
      }

      .frame {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content {
      padding: 0 8px;

      .name {
        padding-top: 6px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:last-child {
          padding-bottom: 6px;
        }
      }

      .tags {
        display: flex;
        flex-wrap: wrap;

        .tag {
          margin-top: 8px;
          margin-right: 8px;
          height: 23px;
          line-height: 23px;
          background: #fff4e6;
          border-radius: 4px;
          padding: 0 6px;
          font-size: 12px;
          color: #ff960a;
        }
      }

      .extra {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .price {
          font-size: 18px;
          font-weight: bold;
          color: #ff3b30;
          line-height: 25px;

          span {
            font-size: 12px;
            font-weight: normal;
            color: #ff3b30;
            line-height: 17px;
          }

          i {
            font-style: normal;
            margin-left: 2px;
            font-size: 12px;
            font-weight: normal;
            color: #b4b4b4;
            line-height: 17px;
          }
        }

        .sales {
          font-size: 12px;
          color: #b4b4b4;
          line-height: 17px;
        }

        &:last-child {
          padding-bottom: 8px;
        }
      }

      .strategy {
        margin: 0 -8px;
        margin-top: 8px;
        background: linear-gradient(171deg, #ffffff 0%, #f2e5d6 100%);
        border-radius: 8px;
        padding: 8px;
        display: flex;
        align-items: flex-end;

        .strategyContent {
          flex-grow: 1;
          overflow: hidden;

          .strategyName {
            font-size: 14px;
            font-weight: bold;
            color: #806249;
            line-height: 20px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .strategyDesc {
            font-size: 12px;
            color: #b89476;
            line-height: 17px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .strategyArrow {
          flex-shrink: 0;
          margin-left: 8px;
          width: 18px;
          height: 18px;
          margin-bottom: 2px;
        }

        &:first-child {
          margin-top: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        }
      }
    }
  }
</style>
